import { render } from "./digitalize.vue?vue&type=template&id=27bd486c&scoped=true"
import script from "./digitalize.vue?vue&type=script&lang=js"
export * from "./digitalize.vue?vue&type=script&lang=js"

import "./digitalize.vue?vue&type=style&index=0&id=27bd486c&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bd486c"]])

export default __exports__